'use client';

import Image from 'next/image';

interface ImageWithWatermarkProps {
  src: string;
  alt: string;
  showWatermark?: boolean;
  className?: string;
  fill?: boolean;
  sizes?: string;
  priority?: boolean;
  quality?: number;
  onLoad?: () => void;
  onClick?: () => void;
  objectPosition?: string;
}

/**
 * Image component with optional copyright watermark overlay
 * Displays "© Ray Saltini" in the lower-right corner when showWatermark is true
 */
export default function ImageWithWatermark({
  src,
  alt,
  showWatermark = true,
  className = '',
  fill = false,
  sizes,
  priority = false,
  quality = 90,
  onLoad,
  onClick,
  objectPosition,
}: ImageWithWatermarkProps) {
  return (
    <>
      {fill ? (
        <Image data-component-id="src/components/ui/ImageWithWatermark.tsx:39:8" data-component-path="src/components/ui/ImageWithWatermark.tsx" data-component-line="39" data-component-end-line="50" data-component-file="ImageWithWatermark.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3Asrc%5D%22%2C%22alt%22%3A%22%5Bvar%3Aalt%5D%22%7D"
          src={src}
          alt={alt}
          fill
          sizes={sizes}
          priority={priority}
          quality={quality}
          onLoad={onLoad}
          onClick={onClick}
          className={`object-cover ${className}`}
          style={objectPosition ? { objectPosition } : undefined}
        />
      ) : (
        <Image data-component-id="src/components/ui/ImageWithWatermark.tsx:52:8" data-component-path="src/components/ui/ImageWithWatermark.tsx" data-component-line="52" data-component-end-line="64" data-component-file="ImageWithWatermark.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3Asrc%5D%22%2C%22alt%22%3A%22%5Bvar%3Aalt%5D%22%7D"
          src={src}
          alt={alt}
          width={1200}
          height={675}
          sizes={sizes}
          priority={priority}
          quality={quality}
          onLoad={onLoad}
          onClick={onClick}
          className={`w-full h-full object-cover ${className}`}
          style={objectPosition ? { objectPosition } : undefined}
        />
      )}
      {showWatermark && (
        <div data-component-id="src/components/ui/ImageWithWatermark.tsx:67:8" data-component-path="src/components/ui/ImageWithWatermark.tsx" data-component-line="67" data-component-end-line="71" data-component-file="ImageWithWatermark.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20pointer-events-none%20select-none%20z-10%22%7D" className="absolute inset-0 pointer-events-none select-none z-10">
          <div data-component-id="src/components/ui/ImageWithWatermark.tsx:68:10" data-component-path="src/components/ui/ImageWithWatermark.tsx" data-component-line="68" data-component-end-line="70" data-component-file="ImageWithWatermark.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20bottom-4%20right-6%20bg-black%2F75%20backdrop-blur-sm%20px-3%20py-1.5%20rounded-lg%20text-white%20text-%5B11px%5D%20font-semibold%20shadow-md%22%2C%22textContent%22%3A%22%C2%A9%20Ray%20Saltini%22%7D" className="absolute bottom-4 right-6 bg-black/75 backdrop-blur-sm px-3 py-1.5 rounded-lg text-white text-[11px] font-semibold shadow-md">
            © Ray Saltini
          </div>
        </div>
      )}
    </>
  );
}

